var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _path10, _path11, _g3, _path12, _g4, _path13, _path14, _path15, _path16, _g5, _path17, _g6, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 63,
    viewBox: "0 0 80 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3266 28.0041V28.6757C46.3266 31.7251 44.6941 33.9826 40.5484 33.9826C36.9633 33.9826 34.9941 32.4922 34.4772 30.0691C31.2312 30.3917 28.1503 30.4817 25.5586 30.283C25.9729 33.483 27.677 36.4049 31.1199 38.3777C33.8392 39.9359 37.1735 40.6122 40.5051 40.6122C43.9816 40.6122 47.4369 39.9095 50.1754 38.1607C53.8385 35.8213 55.2079 32.2859 55.2079 28.6757V25.0294C52.7351 26.156 49.6533 27.1697 46.3266 28.0041Z",
    fill: "url(#paint0_linear_146_4062)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.457 13.7405V27.4669C26.2798 27.5129 27.1764 27.5297 28.137 27.5172C29.6453 27.4975 31.8284 27.3478 34.3383 27.0752V13.7405H25.457Z",
    fill: "url(#paint1_linear_146_4062)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3269 13.7406V25.1192C49.8166 24.3298 53.0184 23.3553 55.2082 22.2086V13.7406H46.3269Z",
    fill: "url(#paint2_linear_146_4062)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 63
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -7.62939e-06H79.8804V63H0V-7.62939e-06Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_146_4062)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 13,
    width: 10,
    height: 10
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 13,
    width: 10,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.457 13.7404H34.3383V22.0202H25.457V13.7404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_146_4062)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.457 13.7405H34.3383V22.0202H25.457V13.7405Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 13,
    width: 10,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.457 13.7404H34.3383V22.0202H25.457V13.7404Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_146_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.457 22.0202H34.3383V13.7405H25.457V22.0202Z",
    fill: "url(#paint3_linear_146_4062)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_146_4062)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 13,
    width: 10,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.457 13.7404H34.3383V22.0202H25.457V13.7404Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_146_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.457 22.0197V13.74H34.3383V16.4598C27.3219 18.8743 25.457 22.0197 25.457 22.0197Z",
    fill: "#FCE2A6"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 13,
    width: 8,
    height: 2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 13,
    width: 8,
    height: 2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3264 13.7404H53.4637V14.0769H46.3264V13.7404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_146_4062)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3264 13.7404H53.4636V14.0769H46.3264V13.7404Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 13,
    width: 8,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3264 13.7405H53.4637V14.0769H46.3264V13.7405Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_146_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3264 14.0769H53.4636V13.7405H46.3264V14.0769Z",
    fill: "url(#paint4_linear_146_4062)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_146_4062)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 13,
    width: 8,
    height: 2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3264 13.74H53.4637V14.0764H46.3264V13.74Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_146_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3264 13.7405H53.4636C50.8592 13.7605 48.4864 13.88 46.3264 14.077V13.7405Z",
    fill: "#FCE2A6"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8621 18.5101C57.701 18.8148 58.2313 19.2142 58.394 19.7082C60.2822 25.4426 35.9998 28.7675 28.4781 28.8656C23.7668 28.9271 20.5913 28.2834 20.1479 26.9368C20.03 26.5789 20.1114 26.1903 20.3725 25.7797C18.9897 26.7843 18.3573 27.7256 18.6033 28.5333C20.966 36.293 63.7245 28.5274 61.2189 20.4096C60.9226 19.4495 59.3329 18.8197 56.8622 18.5101H56.8621Z",
    fill: "url(#paint5_linear_146_4062)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 32,
    width: 27,
    height: 9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 32,
    width: 27,
    height: 9
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 32.4192H54.6564V40.6124H28.7148V32.4192Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_146_4062)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 32.4192H54.6563V40.6123H28.7148V32.4192Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 32,
    width: 27,
    height: 9
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 32.4188H54.6564V40.6119H28.7148V32.4188Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_146_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 40.6125H54.6563V32.4193H28.7148V40.6125Z",
    fill: "url(#paint6_linear_146_4062)"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_146_4062)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_146_4062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 32,
    width: 27,
    height: 9
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 32.4192H54.6564V40.6124H28.7148V32.4192Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_146_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4457 36.1722C47.2598 37.9211 43.24 38.6237 39.1956 38.6237C35.4966 38.6237 31.7949 38.0078 28.7148 36.5972C29.3971 37.2505 30.196 37.8485 31.1201 38.378C33.8394 39.9362 37.1737 40.6125 40.5053 40.6125C43.9818 40.6125 47.4371 39.9098 50.1756 38.161C52.5465 36.6468 53.9565 34.6316 54.6563 32.4194C53.7217 33.8425 52.3502 35.1268 50.4457 36.1722Z",
    fill: "#F3F3F3"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5138 44.9755C27.2446 44.9755 27.0152 45.0503 26.8256 45.1999C26.6314 45.3531 26.5344 45.5339 26.5344 45.7427V50.5076C26.5344 50.685 26.4593 50.8399 26.3094 50.9721C26.1417 51.1148 25.9366 51.186 25.694 51.186C25.4513 51.186 25.2462 51.1148 25.0786 50.9721C24.9241 50.833 24.847 50.6781 24.847 50.5076V45.7427C24.847 45.5305 24.7521 45.3495 24.5624 45.1999C24.3727 45.0503 24.1432 44.9755 23.8742 44.9755H23.4441V50.4919C23.4441 50.9721 23.6691 51.4035 24.1191 51.7862C24.5602 52.1238 25.0852 52.2925 25.694 52.2925C26.316 52.2925 26.8454 52.1202 27.2822 51.7758C27.7232 51.4279 27.9439 51.0086 27.9439 50.518V44.9755H27.5138Z",
    fill: "url(#paint7_linear_146_4062)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5482 49.0983L30.4902 44.9753H31.3174C31.732 44.9753 32.0387 45.1458 32.2372 45.4868L33.2563 47.7779L34.2687 45.492C34.4673 45.1475 34.7738 44.9753 35.1885 44.9753H36.0157L33.9577 49.0983V51.5251C33.9577 51.7374 33.8628 51.9183 33.6732 52.0679C33.4835 52.2175 33.2518 52.2923 32.9784 52.2923H32.5482V49.0983Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9649 50.5179C39.9649 50.6988 40.0486 50.8554 40.2164 50.9876C40.3839 51.1199 40.5825 51.1859 40.8119 51.1859C41.0412 51.1859 41.2398 51.1199 41.4075 50.9876C41.5706 50.8589 41.6523 50.7023 41.6523 50.5179V46.7498C41.6523 46.5654 41.5706 46.4089 41.4075 46.2801C41.2398 46.1479 41.0412 46.0818 40.8119 46.0818C40.5825 46.0818 40.3839 46.1479 40.2164 46.2801C40.0486 46.4124 39.9649 46.5689 39.9649 46.7498V50.5179ZM38.562 46.7498C38.562 46.2592 38.7804 45.84 39.2172 45.492C39.6627 45.1476 40.1942 44.9753 40.8119 44.9753C41.434 44.9753 41.9633 45.1476 42.4001 45.492C42.8411 45.84 43.0618 46.2592 43.0618 46.7498V50.5179C43.0618 51.0085 42.8411 51.4278 42.4001 51.7756C41.9633 52.1201 41.434 52.2923 40.8119 52.2923C40.1987 52.2923 39.6693 52.1201 39.2238 51.7756C38.7826 51.4278 38.562 51.0085 38.562 50.5179V46.7498Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0113 50.5179C47.0113 50.6988 47.095 50.8554 47.2627 50.9876C47.4303 51.1199 47.6289 51.1859 47.8583 51.1859C48.0876 51.1859 48.2861 51.1199 48.4539 50.9876C48.617 50.8589 48.6987 50.7023 48.6987 50.5179V46.7498C48.6987 46.5654 48.617 46.4089 48.4539 46.2801C48.2861 46.1479 48.0876 46.0818 47.8583 46.0818C47.6289 46.0818 47.4303 46.1479 47.2627 46.2801C47.095 46.4124 47.0113 46.5689 47.0113 46.7498V50.5179ZM45.6084 46.7498C45.6084 46.2592 45.8268 45.84 46.2635 45.492C46.7091 45.1476 47.2406 44.9753 47.8583 44.9753C48.4803 44.9753 49.0097 45.1476 49.4465 45.492C49.8875 45.84 50.1082 46.2592 50.1082 46.7498V50.5179C50.1082 51.0085 49.8875 51.4278 49.4465 51.7756C49.0097 52.1201 48.4803 52.2923 47.8583 52.2923C47.245 52.2923 46.7157 52.1201 46.2701 51.7756C45.8289 51.4278 45.6084 51.0085 45.6084 50.5179V46.7498Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3071 49.7089V45.9356C56.3071 45.6713 56.4262 45.4451 56.6644 45.2572C56.9026 45.0693 57.1915 44.9753 57.5313 44.9753H57.7166V52.2923H56.8828C56.4769 52.2923 56.1703 52.1219 55.963 51.7809L54.0572 47.5796V51.5251C54.0572 51.7374 53.9623 51.9184 53.7726 52.0679C53.5829 52.2175 53.3535 52.2923 53.0844 52.2923H52.6543V44.9753H53.2829C53.7946 44.9753 54.1763 45.1859 54.4278 45.6069L56.3071 49.7089Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_4062",
    x1: 39.9615,
    y1: 30.8726,
    x2: 42.127,
    y2: 46.9547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99957,
    stopColor: "#9D9C9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_146_4062",
    x1: 32.4107,
    y1: 29.8015,
    x2: 28.675,
    y2: 7.89486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998343,
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_146_4062",
    x1: 52.6641,
    y1: 26.3478,
    x2: 48.9284,
    y2: 4.44123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998343,
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_146_4062",
    x1: 28.667,
    y1: 3.76776,
    x2: 29.6633,
    y2: 22.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_146_4062",
    x1: 48.9148,
    y1: 2.66941,
    x2: 49.9112,
    y2: 21.0372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_146_4062",
    x1: 41.6517,
    y1: 31.5768,
    x2: 40.7291,
    y2: 21.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00478F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998492,
    stopColor: "#47EADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47EADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_146_4062",
    x1: 43.7702,
    y1: 47.1111,
    x2: 42.3806,
    y2: 35.7567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_146_4062",
    x1: 23.4441,
    y1: 48.634,
    x2: 27.9439,
    y2: 48.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998343,
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.e0e7e37dfa88b374299ac4b5cf040592.svg";
export { ForwardRef as ReactComponent };